/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiCornerOutUpRightIcon16Regular = forwardRef('ArrowUiCornerOutUpRightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.5 2.75A1.75 1.75 0 0 0 2.75 4.5v7c0 .966.784 1.75 1.75 1.75h7a1.75 1.75 0 0 0 1.75-1.75V10a.75.75 0 0 1 1.5 0v1.5a3.25 3.25 0 0 1-3.25 3.25h-7a3.25 3.25 0 0 1-3.25-3.25v-7A3.25 3.25 0 0 1 4.5 1.25H6a.75.75 0 0 1 0 1.5H4.5Z" }),
        React.createElement("path", { d: "M13.25 3.81V6.5a.75.75 0 1 0 1.5 0v-4c0-.69-.56-1.25-1.25-1.25h-4a.75.75 0 1 0 0 1.5h2.69L7.47 7.47a.75.75 0 0 0 1.06 1.06l4.72-4.72Z" })));
});
